<template>
    <div class="login-model-pop-up-sec main-login" @click="closeCountryCodeOnOutsideClick">
        <div class="modal fade" id="login-btn" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
            data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <button @click="refreshData()" ref="close_btn" type="button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close">&#10006;</button>
                    <div class="modal-body">
                        <div class="login-body-sec">
                            <div class="login-body-lft">
                                <div class="login-flow-heading">
                                    <div class="web-logo">
                                        <img :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.domain_image + $siteSettings?.data?.logo" alt="logo">
                                    </div>
                                </div>  
                                <div class="login-option-h">
                                    <ul class="nav nav-pills mb-3 login-type-tab" id="pills-tab" role="tablist"  v-if="$siteSettings?.data?.business_type == 2">

                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link phone-tab" :class="form.type == 1 ? 'active': ''" id="phone-login-tab" data-bs-toggle="pill"
                                                data-bs-target="#phone-login" type="button" role="tab"
                                                aria-controls="phone-login" aria-selected="false" @click="chooseFormType('1')">{{ $t('mobile-number','Mobile Number')}}</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link user-tab" :class="form.type == 2 ? 'active': ''" id="user-login-tab" data-bs-toggle="pill"
                                                data-bs-target="#user-login" type="button" role="tab"
                                                aria-controls="user-login" aria-selected="true" @click="chooseFormType('2')">{{ $t('user-id','User ID')}}</button>
                                        </li>
                                    </ul>
                                </div>
                                <!-- business_type == 2 -->
                                <div class="tab-content" id="pills-tabContent">
                                    <div class="tab-pane fade " :class="form.type == 1 ? 'show active': ''" id="phone-login" role="tabpanel"
                                        aria-labelledby="phone-login-tab" v-if="$siteSettings?.data?.business_type == 2">
                                        <div class="input-wrap">
                                            <div class="contact-info-wrapper login-contact">
                                                <div v-if="$siteSettings?.data" class="select-country-code">
                                                    <div class="country-code-flag-top-wrapper" ref="countryCodeWrapper">
                                                        <div class="country-code-flag-top-sec" :class="{ 'disabled': timerRunning }" @click="openCountryCode()">
                                                            <img loading="lazy" :src="siteSettings?.country_code_list[contIndex]?.flag"> <span>+{{ siteSettings?.country_code_list[contIndex]?.phonecode }}</span>
                                                            <i class="fa-solid fa-caret-down" :class="{ 'd-none': timerRunning }"></i>
                                                        </div>
                                                        <ul class="country-code-flag-sec" :class="checkCountryCodeSelect ? 'show-country-code' :''">
                                                            <template v-for="(allowedCountry, countryIndex) in countryCodeList">
                                                                <li v-if="allowedCountry?.phonecode != countryCodeList[contIndex]?.phonecode"
                                                                :key="countryIndex" @click="selectCountryCode(countryIndex,allowedCountry?.phonecode)"><img loading="lazy" :src="allowedCountry?.flag"> <span>+{{ allowedCountry.phonecode }}</span></li>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="input-left">
                                                    <input type="tel" :placeholder="$t('enter-mobile-number','Enter Mobile Number') + '*'" v-model="form.mobileNo" :disabled="resendOtp && timerRunning" required maxlength="10"
                                                    @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo, 9999999999)" class="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div v-if="init && checkValidation?.mobile?.length > 0">
                                                <template v-for="(err, index) in checkValidation?.mobile" :key="index">
                                                    <p class="error-text"> {{ $t(err.lang, err.error) }}</p>
                                                </template>
                                            </div>
                                            <div v-if="init && form.mobileNo.length == 10 && !timerRunning && loginMethod == 'otp'">
                                                <p class="error-text"> {{$t('please-click-on-send-otp','Please Click on Get OTP')}} </p>
                                            </div>
                                        </div>
                                        <div class="login-method-section">
                                            <div class="login-option">
                                                <input class="form-check-input flexRadioDefault-sec" type="radio" @click="clearOTPPassword()" name="login-method" id="login-password" value="password" v-model="loginMethod">
                                                <label for="login-password" class="ps-1 text-white">{{$t('password','Password')}}</label>
                                            </div>
                                            <div class="login-option">
                                                <input class="form-check-input flexRadioDefault-sec" @click="clearOTPPassword()" type="radio" name="login-method" id="login-otp" value="otp" v-model="loginMethod">
                                                <label for="login-otp" class="ps-1 text-white">{{$t('otp','OTP')}}</label>
                                            </div>
                                        </div>
                                        <div class="input-wrap">
                                            <input v-if="loginMethod == 'password'"  :type="passwordFieldType" 
                                                @input="form.password = $helper.sanitizeDetails('oldLoginPassword', form.password);"  
                                                v-model="form.password"  :placeholder="$t('enter-pass','Enter Password') + '*'" class="form-control password-input" />
                                            <input v-model="form.password" class="form-control" id="myPassInput" type="tel" v-if="loginMethod == 'otp'"
                                                :placeholder="$t('enter-otp','Enter OTP')" aria-label="password" @input="form.password = $helper.sanitizeNumber(form.password,999999);"
                                                aria-describedby="addon-wrapping" maxlength="6">
                                            <div class="otp-login-btn" v-if="loginMethod == 'otp'">
                                                <span class="btn send-login-otp" :class="{'disabled' : timerRunning }">
                                                    <span v-if="!loadingOtp" @click="sendOtpServiceCall()">{{ isOtpApiCalled && (minutes > 0 || seconds > 0) ? formatTime(minutes) + ':' + formatTime(seconds) : (minutes == 0 ? $t('resend-otp','Resend OTP') : $t('get-otp','GET OTP')) }}</span>
                                                    <div v-if="loadingOtp" class="text-center" id="Otp_loader">
                                                        <div class="spinner-border" role="status">
                                                            <span class="visually-hidden">{{ $t('loading','Loading') }}...</span>
                                                        </div>
                                                    </div>
                                                </span>
                                                    
                                            </div>
                                            <div class="showHide-pass" v-if="loginMethod == 'password'" @click="togglePasswordVisibility('passwordFieldType')">
                                                <!-- <i class="fa-solid" :class="passwordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i> -->
                                                <img loading="lazy" :src="passwordFieldType === 'password' ? require('@/assets/images/eye-slash.svg') : require('@/assets/images/eye.svg')" alt=""/>
                                            </div>
                                            <div v-if="showValidationError && form.password == ''">
                                                <p class="error-text">{{ $t(`please-enter-${loginMethod.toLowerCase()}`,`Please Enter ${loginMethod == 'password' ? $t('password','Password') : $t('otp','OTP')}.`)}}</p>
                                            </div>
                                            <div v-if="form.password.length > 0 && form.password.length < 6 && loginMethod == 'otp' && showValidationError">
                                                <p class="error-text">{{ $t('otp-6-digit-msg','Please Enter 6 Digit OTP')}}</p>
                                            </div>
                                            <div v-if="init.userId && checkValidation?.password?.length > 0 && loginMethod == 'password'">
                                                <template v-for="(err, index) in checkValidation?.password" :key="index">
                                                    <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                                </template>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane fade" :class="form.type == 2 ? 'show active': ''" id="user-login" role="tabpanel"
                                        aria-labelledby="user-login-tab">
                                        <div class="input-wrap">
                                            <div class="row">
                                                <div class="col-12 col-sm-12 col-md-12">
                                                    <div class="input-left">
                                                        <input type="text" v-model="form.userId" @input="form.userId = $helper.sanitizeDetails('oldLoginUserId', form.userId); " class="form-control password-input"
                                                        :placeholder="$t('enter-user-id','Enter User ID')" />
                                                        <i class="fa-solid fa-user"></i>
                                                    </div>
                                                </div>

                                                <div v-if="init && checkValidation?.userId?.length > 0">
                                                    <template v-for="(err, index) in checkValidation?.userId" :key="index">
                                                        <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                                    </template>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="input-wrap">
                                            <input v-if="loginMethod == 'password'"  :type="passwordFieldType" 
                                                @input="form.password = $helper.sanitizeDetails('oldLoginPassword', form.password);"  
                                                v-model="form.password"  :placeholder="$t('enter-pass','Enter Password') + '*'" class="form-control password-input" />

                                            <div class="showHide-pass" v-if="loginMethod == 'password'" @click="togglePasswordVisibility('passwordFieldType')">
                                                <!-- <i  class="fa-solid" :class="passwordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i> -->
                                                <img loading="lazy" :src="passwordFieldType === 'password' ? require('@/assets/images/eye-slash.svg') : require('@/assets/images/eye.svg')" alt=""/>
                                            </div>

                                            <div v-if="init && checkValidation?.password?.length > 0 && loginMethod == 'password'">
                                                <template v-for="(err, index) in checkValidation?.password" :key="index">
                                                    <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div action="">
                                    <div v-if="$siteSettings?.data?.business_type == 2" class="input-wrap box-right">
                                        <a @click="refreshData()" href="#forget-password-btn" data-bs-toggle="modal">{{ $t('forgot-password','Forgot Password?') }}</a>
                                    </div>

                                    <div class="login-cmn-btn">
                                        <button type="button" @click="demoUserLogin()">
                                            <span v-if="!demoLoading">{{ $t('demo-login','Login with Demo ID')}}</span>
                                            <div v-if="demoLoading" class="text-center" id="Otp_loader">
                                                <div class="spinner-border" role="status">
                                                    <span class="visually-hidden">{{ $t('loading','Loading') }}...</span>
                                                </div>
                                            </div>
                                        </button>
                                        <button @click="signInMethodCall()" :disabled="loading" type="button">
                                            <span v-if="!loading">{{ $t('log-in','Log In') }}</span>
                                            <div v-if="loading" class="text-center" id="Otp_loader">
                                                <div class="spinner-border" role="status">
                                                    <span class="visually-hidden">{{ $t('loading','Loading') }}...</span>
                                                </div>
                                            </div>
                                        </button>


                                    </div>
                                    <div class="download-btnWrap">
                                        <a v-if="siteSettings?.apk" :href="siteSettings.aws_url + siteSettings.storage_path.apk_path + siteSettings.apk" :download="siteSettings.apk" class="downloadApp-btn">
                                            <span>{{$t('download-apk','Download APK')}}</span>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.102 2.42459L14.364 0.555334C14.4737 0.392912 14.4305 0.170334 14.2681 0.0606463C14.1057 -0.0490022 13.8831 -0.00579907 13.7735 0.156584L12.4701 2.08713C11.7174 1.74365 10.881 1.55225 9.99994 1.55225C9.11896 1.55225 8.28248 1.74365 7.52986 2.08717L6.22642 0.156584C6.11677 -0.00579907 5.89416 -0.0490022 5.73177 0.0606463C5.56935 0.170334 5.52619 0.392873 5.63584 0.555334L6.89787 2.42459C5.31341 3.3933 4.2156 5.08022 4.06162 7.03303H15.9383C15.7843 5.08022 14.6865 3.39338 13.102 2.42459ZM7.57615 5.23401C7.11701 5.23401 6.74478 4.86182 6.74478 4.40264C6.74478 3.94346 7.11701 3.57127 7.57615 3.57127C8.03529 3.57127 8.40751 3.94346 8.40751 4.40264C8.40751 4.86182 8.03529 5.23401 7.57615 5.23401ZM12.4238 5.23401C11.9646 5.23401 11.5924 4.86182 11.5924 4.40264C11.5924 3.94346 11.9646 3.57127 12.4238 3.57127C12.8829 3.57127 13.2551 3.94346 13.2551 4.40264C13.2551 4.86182 12.8829 5.23401 12.4238 5.23401Z" fill="currentColor"/>
                                                <path d="M3.97076 16.4073C3.97076 16.9465 4.41138 17.3871 4.9506 17.3871H6.5706V18.9905C6.5706 19.5451 7.02431 20 7.58013 20C8.13474 20 8.58966 19.5451 8.58966 18.9905V17.3871H11.4401V18.9905C11.4401 19.5451 11.8938 20 12.4496 20C13.0043 20 13.4592 19.5451 13.4592 18.9905V17.3871H14.8677C15.4058 17.3871 15.8476 16.9465 15.8476 16.4073V8.08443H3.97076V16.4073Z" fill="currentColor"/>
                                                <path d="M1.82611 8.08443C1.18447 8.08443 0.659546 8.60936 0.659546 9.251V13.0938C0.659546 13.7354 1.18451 14.2603 1.82611 14.2603C2.46771 14.2603 2.99267 13.7354 2.99267 13.0938V9.251C2.99267 8.6094 2.46771 8.08443 1.82611 8.08443Z" fill="currentColor"/>
                                                <path d="M18.1738 8.08443C17.5322 8.08443 17.0072 8.60936 17.0072 9.251V13.0938C17.0072 13.7354 17.5322 14.2603 18.1738 14.2603C18.8154 14.2603 19.3404 13.7354 19.3404 13.0938V9.251C19.3403 8.6094 18.8154 8.08443 18.1738 8.08443Z" fill="currentColor"/>
                                            </svg>
                                        </a>
                                        <a v-else @click="$helper.openModal('#install-apk-model')" class="downloadApp-btn">
                                            <span>{{$t('download-apk','Download APK')}}</span>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.102 2.42459L14.364 0.555334C14.4737 0.392912 14.4305 0.170334 14.2681 0.0606463C14.1057 -0.0490022 13.8831 -0.00579907 13.7735 0.156584L12.4701 2.08713C11.7174 1.74365 10.881 1.55225 9.99994 1.55225C9.11896 1.55225 8.28248 1.74365 7.52986 2.08717L6.22642 0.156584C6.11677 -0.00579907 5.89416 -0.0490022 5.73177 0.0606463C5.56935 0.170334 5.52619 0.392873 5.63584 0.555334L6.89787 2.42459C5.31341 3.3933 4.2156 5.08022 4.06162 7.03303H15.9383C15.7843 5.08022 14.6865 3.39338 13.102 2.42459ZM7.57615 5.23401C7.11701 5.23401 6.74478 4.86182 6.74478 4.40264C6.74478 3.94346 7.11701 3.57127 7.57615 3.57127C8.03529 3.57127 8.40751 3.94346 8.40751 4.40264C8.40751 4.86182 8.03529 5.23401 7.57615 5.23401ZM12.4238 5.23401C11.9646 5.23401 11.5924 4.86182 11.5924 4.40264C11.5924 3.94346 11.9646 3.57127 12.4238 3.57127C12.8829 3.57127 13.2551 3.94346 13.2551 4.40264C13.2551 4.86182 12.8829 5.23401 12.4238 5.23401Z" fill="currentColor"/>
                                                <path d="M3.97076 16.4073C3.97076 16.9465 4.41138 17.3871 4.9506 17.3871H6.5706V18.9905C6.5706 19.5451 7.02431 20 7.58013 20C8.13474 20 8.58966 19.5451 8.58966 18.9905V17.3871H11.4401V18.9905C11.4401 19.5451 11.8938 20 12.4496 20C13.0043 20 13.4592 19.5451 13.4592 18.9905V17.3871H14.8677C15.4058 17.3871 15.8476 16.9465 15.8476 16.4073V8.08443H3.97076V16.4073Z" fill="currentColor"/>
                                                <path d="M1.82611 8.08443C1.18447 8.08443 0.659546 8.60936 0.659546 9.251V13.0938C0.659546 13.7354 1.18451 14.2603 1.82611 14.2603C2.46771 14.2603 2.99267 13.7354 2.99267 13.0938V9.251C2.99267 8.6094 2.46771 8.08443 1.82611 8.08443Z" fill="currentColor"/>
                                                <path d="M18.1738 8.08443C17.5322 8.08443 17.0072 8.60936 17.0072 9.251V13.0938C17.0072 13.7354 17.5322 14.2603 18.1738 14.2603C18.8154 14.2603 19.3404 13.7354 19.3404 13.0938V9.251C19.3403 8.6094 18.8154 8.08443 18.1738 8.08443Z" fill="currentColor"/>
                                            </svg>
                                        </a>
                                    </div>
                                    <div class="Continue-with" v-if="siteSettings?.business_type == 2 && $siteSettings?.data?.social_link?.whatsappno1">
                                        <h3 class="whats-with">{{ $t('get-your-ready-made-id-from-whatsapp','Get Your Ready-Made ID From WhatsApp')}} <span class="whats-with-now-add"></span></h3>
                                                
                                        <div class="button-whatsapp">
                                            <a :href="'https://wa.me/' + $siteSettings?.data?.social_link?.whatsappno1" target="_blank" class="btn-whatsapp" > 
                                                <img src="@/assets/images/whatsapp-social.svg"> {{ $t('whatsapp-now','Whatsapp Now') }}</a>
                                        </div>
                                    </div>

                                    <div class="logon-option" v-if="$siteSettings?.data?.business_type == 2">

                                        <div class="or-login-with">
                                            {{ $t('or-login-with','or Login with') }}
                                        </div>

                                        <ul class="submenu social-icons mb-2">
                                            <li>
                                                <a :href="$siteSettings?.data?.social_link?.facebook_link" target="_blank" rel="noopener" class="facebook">
                                                    <img loading="lazy" src="@/assets/images/facebook-logo.webp" alt="facebook icon" />
                                                </a>
                                            </li>
                                          
                                            <li>
                                                <a :href="$siteSettings?.data?.social_link?.instagram_link" target="_blank" rel="noopener" class="twitter">
                                                    <img loading="lazy" src="@/assets/images/instagram-logo.webp" alt="instagram icon" />
                                                </a>
                                            </li>
                                            <li>
                                                <a :href="$siteSettings?.data?.social_link?.telegram_link" target="_blank" class="email">
                                                    <img loading="lazy" src="@/assets/images/telegram-logo.webp" alt="telegram icon" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <p class="forpass-in" v-if="$siteSettings?.data?.business_type == 2">
                                        {{ $t('dont-have-an-account',`Don't have an account `) }}?
                                        <a @click="refreshData" href="#register-btn" data-bs-toggle="modal">{{ $t('register','Register') }}</a>
                                    </p>
                                </div>

                            </div>
                            <div class="login-body-rgt">
                                <div class="banner-side-img-sec">
                                    <div class="slider-model-pic">
                                        <div class="slider-model-pic">
                                            <img loading="lazy" src="@/assets/images/sl-lc-one-layer-two.webp" alt="one-layer" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { AUTH_TOKEN } from '@/shared/constants/cookies-const';
import axios from 'axios';
import { setHeaders } from '@/shared/services/headers';
import validate from '../services/authValidation';
import commonAuth from '@/modules/authorization/services/commonAuth';
import { mapGetters } from 'vuex';

export default {
    name: "Login",
    extends: commonAuth,
    data() {
        return {
            form: {
                code: this.$siteSettings.data && this.$siteSettings.data.country_code ? this.$siteSettings.data.country_code : "91",
                mobileNo: "",
                userId: "",
                password: "",
                type: this.$siteSettings?.data?.business_type == 2 ? 1 : 2,
            },
            styleObject: {
                display: "none",
            },
            modal: null,
            checkCountryCodeSelect:false,
            defaultCountryCode : this.$store?.getters?.siteSettings?.country_code,
            demoLoading:false,
            init: false,
            loading:false,
            passwordFieldType: 'password',
            loggedUserCheck: null,
            inputvalue: [
                {
                value: 100,
                },
                {
                value: 500,
                },
                {
                value: 1000,
                },
                {
                value: 2000,
                },
            ],
            minutes: 5,
            seconds: 59,
            showValidationError: false,
        };
    },
    mounted() {
        this.loggedUserCheck = localStorage.getItem("LoggedUser");
        this.contIndex =  this.countryCodeList?.findIndex(ci => ci.phonecode == this.defaultCountryCode)
        if(localStorage.getItem('login_type') && this.siteSettings?.business_type == 2) {
            let type = localStorage.getItem('login_type');
            if(type == 'demo')
                this.form.type = 1;
            else
                this.form.type = localStorage.getItem('login_type');
        }
        this.form.type = this.$siteSettings?.data?.business_type == 1 ? 2 : 1;
        if (this.$route.name == 'login' && !this.$auth?.status) {
            setTimeout(()=> {
                this.$helper.openModal('#login-btn')
            }, 500)
            this.$router.push({name: 'Home'})
        }
        else if (this.$route.name == 'login' && this.$auth?.status) {
            this.$router.push('/')
        }
    },
    computed: {
        ...mapGetters({
            siteSettings: 'siteSettings'
        }),
        countryCodeList(){
            return this.$store?.getters?.siteSettings?.country_code_list;
        },
        checkValidation() {
            const validationErrors = validate.areFieldsValid(
                'login', 
                this.form.type, 
                this.form.mobileNo, 
                this.form.userId, 
                this.form.password
            );
            if(this.init){
                return validationErrors;
            }
        }
    },
    methods: {
        getId() {
            if (this.siteSettings?.business_type == 2) {
                return this.form.type == 1 ? this.form.mobileNo : this.form.userId;
            } else {
                return this.form.userId;
            }
        },
        clearOTPPassword(){
            this.form.password = '';
        },
        closeCountryCodeOnOutsideClick(event) {
            const countryCodeElement = this.$refs.countryCodeWrapper;
            // const countryCodeElement = this.$el.querySelector('.country-code-flag-top-wrapper');
            if (countryCodeElement && event && event.target && !countryCodeElement.contains(event.target)) {
                this.checkCountryCodeSelect = false;
            }
        },
        selectCountryCode(code,phone_code){
            this.contIndex = code;
            this.form.code = parseInt(phone_code)
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        openCountryCode(){
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        demoUserLogin() {
            this.form.type = 1;
            this.form.userId = "demouser";
            this.form.password = "demopass";
            this.loginServiceCall('DEMO_LOGIN_API', 'demo')
        },
        signInMethodCall() {
            this.init = true;
            let id = this.getId();
            if (id == "" || this.form.password == "") {
                this.showValidationError = true;
            }
            else{    

                if(this.loginMethod == 'otp'){
                    if(this.isOtpApiCalled)
                    {
                        this.signInWithOtp();
                    }
                }
                else{
                    this.loginServiceCall('LOGIN_API', 'nondemo');
                }
            }
        },
        async loginServiceCall(url, type) {
            if (type == 'demo') {
                this.demoLoading = true;
            } else {
                this.loading = true;
            }
            let id = this.getId();
            type == 'demo' ? this.demoLoading = true : this.loading = true;
            let data = {
                "userid": id.toString(),
                "type": this.siteSettings?.business_type == 1 ? 2 : this.form.type,
                "cncode": this.form.code,
                "password": this.form.password
            };
            this.$apiCall('post', url, data).then(response => {
                type == 'demo' ? this.demoLoading = false : this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            this.$successToast(response.data.message);
                            let userData = response.data.data;
                            if(this.loggedUserCheck!=userData.userid){
                                this.$store.dispatch('setClickBetValue',this.inputvalue);
                                this.$store.dispatch('setIsClickBetOn',false);
                            }
                            this.$cookies.set(AUTH_TOKEN, userData.token);
                            window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                            //for add on all APIs
                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                            localStorage.setItem("LoggedUser",userData.userid)
                            if(type == 'demo'){
                                localStorage.setItem('UserIdorLogin', 2)
                                localStorage.setItem('login_type', 'demo')
                                localStorage.setItem('isDemo', 'isDemo')
                            } else {
                                localStorage.setItem('UserIdorLogin', data.type)
                                localStorage.setItem('login_type', data.type)
                            }			
                            setHeaders()
                            this.setUserDataToStore(userData);
                            this.refreshData();
                            this.closeModal();
                            this.$router.push({ name: 'Home' });
                            setTimeout(()=>{
                                window.location.reload();
                            },500)
                        }
                    }
                }
            }).catch(error => {
                this.$errorToast(error);
                type == 'demo' ? this.demoLoading = false : this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        closeModal() {
            this.$helper.closeModal('login-btn')
        },
        setUserDataToStore(userData) {
            let asciiCodes = null;
            for (let i = 0; i < userData.userid.length; i++) {
                asciiCodes += userData.userid.charCodeAt(i)
            }

            let user =
            {
                balance: userData.balance,
                currency: userData.currency,
                currency_slug: userData.currency_slug,
                last_login_at: userData.last_login_at,
                name: userData.name,
                role_id: userData.role_id,
                userid: userData.userid,
                exposure: userData.expl,
                available_credits: userData.available_credits,
                is_fresh: userData.is_fresh,
                id: userData.id,
                exp: userData.exp,
                activeWallet: userData.actw,
                cpi: userData.cpi,
                notificationSubscribed:null,
                notificationUnsubscribed:null,
                asciiCodes: asciiCodes,
            }

            this.$store.dispatch('setUser', user);
            this.$store.dispatch('setChips', userData.chips);
            this.$store.dispatch('setEventManage', userData.lock_settings);
        },
        chooseFormType(formType) {
            this.form.type !== formType && this.refreshData();
            this.form.type = formType;
            this.loginMethod = "password";
        },
        togglePasswordVisibility(fieldName) {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        },
        signInWithOtp() {
            let id = this.getId();
            this.loading = true;
            let data = {
                mobile: id,
                countrycode: this.form.code,
                otp: this.form.password
            };

            this.$apiCall('post','LOGIN_WITH_OTP', data).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.showErrorModalFunc(response.data.debug[0]);
                        } else {
                        
                            this.$successToast(response.data.message);
                            let userData = response.data.data;
                            if(this.loggedUserCheck!=userData.userid){
                                this.$store.dispatch('setClickBetValue',this.inputvalue);
                            }
                            this.$cookies.set(AUTH_TOKEN, userData.token);
                            this.$store.dispatch('setToken', `Bearer ${userData.token}`);
                            window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                            //for add on all APIs
                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                            localStorage.setItem("LoggedUser",userData.userid)
                            this.$store.dispatch('setSiteVersion', null);
                            setHeaders();
                            this.setUserDataToStore(userData);
                            this.$store.dispatch('setLoggedUser',userData.userid)
                            location.reload();
                            this.closeModal();
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
    }
};
</script>

<style scoped>

div.mm-dropdown ul li {
    display: flex !important;
    padding-left: 25px;
}

.login-type-tab {
    width: 100%;
    height: 36px;
    margin: 0 auto;
}

.phone-tab {
    height: 36px;
    padding: 0px;
}

.user-tab {
    padding: 5px;
}

</style>